import actionCreatorFactory from 'typescript-fsa';
import { MessagePack } from '../types'

const actionCreator = actionCreatorFactory('MessageAction');
export const MessageActions = {
    push: actionCreator<MessagePack>('push'),
    removePopup: actionCreator('removePopup'),
    removeFirstPopup: actionCreator('removeFirstPopup'),
}